import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, RoutesRecognized, ActivatedRoute, Params } from '@angular/router';
import { filter, pairwise } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { AgentDashboardComponent } from '../agent-dashboard/agent-dashboard.component';

@Component({
  selector: 'app-par-nav-tab',
  templateUrl: './par-nav-tab.component.html',
  styleUrls: ['./par-nav-tab.component.css']
})
export class ParNavTabComponent implements OnInit {
  clientDisable: any;
  clientHidden: any;
  public role: string;
  public fxDisplay: any = 100;
  navTabs = ['Dashboard', 'Summary', 'Due Diligence', 'Insurance', 'License', 'Employees', 'State Requirements', 'Change Log'];
  navTabsClient = ['Dashboard', 'Summary ', 'Due Diligence', 'Insurance', 'License', 'Employees', 'State Requirements'];
  activeTab;
  routerLink;
  showTabComponent: boolean = false;
  parRouting:boolean = false;

  constructor(public router: Router, public activatedRoute: ActivatedRoute) { }
  ngOnInit() {
    if (this.activatedRoute.snapshot.params["docType"] !== undefined && this.activatedRoute.snapshot.params["docType"] !== '') {
      if (this.activatedRoute.snapshot.params["docType"] === 'PARDUEDILIGENCE')
        this.activeTab = 'Due Diligence';
      else if (this.activatedRoute.snapshot.params["docType"] === 'Summary')
        this.activeTab = 'Summary';
      else if (this.activatedRoute.snapshot.params["docType"] === 'SummaryClient')
        this.activeTab = 'Summary ';
      else if (this.activatedRoute.snapshot.params["docType"] === 'Dashboard')
        this.activeTab = 'Dashboard';
      else if (this.activatedRoute.snapshot.params["docType"] === 'PARLICENSE')
        this.activeTab = 'License';
      else if (this.activatedRoute.snapshot.params["docType"] === 'PAREMPLOYEE')
        this.activeTab = 'Employees';
      else if (this.activatedRoute.snapshot.params["docType"] === 'STATEREQUIREMENTS')
        this.activeTab = 'State Requirements';
      else if (this.activatedRoute.snapshot.params["docType"] === 'PARINSURANCE')
        this.activeTab = 'Insurance';
      else if (this.activatedRoute.snapshot.params["docType"] === 'CHANGELOG')
        this.activeTab = 'Change Log';
    }
    this.role = localStorage.getItem("Role")
    if (this.role === "PC Client") {
      this.clientDisable = true;
      this.clientHidden = true;
      this.fxDisplay = 50;
    } else {
      this.parRouting = true;
      this.clientDisable = false;
      this.clientHidden = false;
      this.fxDisplay = 100;
    }
  }

  selectedTab(tab) {
    if (tab === 'Dashboard')
      this.router.navigate(['par/dashboard', 'Dashboard']);
    else if (tab === 'Summary ')
      this.router.navigate(['par/summaryClient', 'SummaryClient']);
    else if (tab === 'Summary')
      this.router.navigate(['par/summary', 'Summary']);
    else if (tab === 'Due Diligence')
      this.router.navigate(['par/duediligence', 'PARDUEDILIGENCE']);
    else if (tab === 'Insurance')
      this.router.navigate(['par/insurance', 'PARINSURANCE']);
    else if (tab === 'License')
      this.router.navigate(['par/license', 'PARLICENSE']);
    else if (tab === 'Employees')
      this.router.navigate(['par/employee', 'PAREMPLOYEE']);
    else if (tab === 'State Requirements')
      this.router.navigate(['par/staterequirements', 'STATEREQUIREMENTS']);
    else if (tab === 'Change Log')
      this.router.navigate(['par/changelog', 'CHANGELOG']);
  }

  ngAfterViewInit() {

  }
}



// WEBPACK FOOTER //
// ./src/app/components/par-nav-tab/par-nav-tab.component.ts